import { getStorageItem } from '../utils/browser';

export type ReduxPath = string[];

export const getPersistedState = (path: ReduxPath, defaultValue: any) =>
  getStorageItem(path.toString(), defaultValue);
